import { FunctionComponent } from 'react';
import styles from './UnitName.module.scss';
import clsx from 'clsx';
import { Input } from 'components/UI/V3/Forms/Input/Input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { RoomUnit } from '@spike/room-model';
import { useDebouncedCallback } from 'use-debounce';
import isEmpty from 'lodash/isEmpty';
import { Switch } from 'components/UI/V3/Forms/Switch';
import { Label } from 'components/UI/V3/Forms/Label/Label';

interface UnitNameProps {
    unit: RoomUnit;
    isEdit?: boolean;
    removable?: boolean;
    errorMessage?: string;
    className?: string;
    onChange?: (unit: RoomUnit) => void;
    onRemove?: () => void;
}

export const UnitName: FunctionComponent<UnitNameProps> = props => {
    const debouncedName = useDebouncedCallback((value: string) => {
        props.onChange?.({ ...props.unit, name: value });
    }, 500);

    const handleActiveChange = (checked: boolean) => {
        props.onChange?.({ ...props.unit, active: checked });
    };

    return (
        <div className={clsx(styles.container, props.className)}>
            {props.isEdit && (
                <Switch
                    className={styles.availableSwitch}
                    checked={props.unit.active}
                    onChange={handleActiveChange}
                />
            )}
            <Input
                value={props.unit.name}
                onChange={event => debouncedName(event.target.value)}
                error={
                    props.errorMessage
                        ? props.errorMessage
                        : isEmpty(props.unit.name?.trim())
                        ? 'Room Name is a required field'
                        : undefined
                }
                withoutSpecialCharacters={true}
                disabled={!props.unit.active}
            />
            {props.removable && (
                <div
                    className={styles.removeContainer}
                    onClick={props.onRemove}
                >
                    <FontAwesomeIcon
                        icon={faTimes}
                        fontSize={18}
                    />
                </div>
            )}
        </div>
    );
};

export default UnitName;
